module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[118]239.b9ed5a1.woff2";